module.exports = __webpack_public_path__ + "static/media/menu-routines-active.a97ee516.svg";